// import {AuthActionTypes, All } from '../actions/authenticationActions';
// import { User } from '../../app/core/interfaces/user';


// export interface State {
//   // is a user authenticated?
//   isAuthenticated: boolean;
//   // if authenticated, there should be a user object
//   user: User | null;
//   // error message
//   errorMessage: string | null;

//   successMessage: string | null;
  

//   tupasVerified : boolean;

//   success : boolean,

//   url:string | null;

//   error: string | null;
// }

// const initialState: State = {
//   isAuthenticated: localStorage.getItem("token") && true || false,
//   user: null,
//   errorMessage: null,
//   successMessage: null,
//   tupasVerified:false,
//   success: null,
//   url:null,
//   error:null
// };

// // export function authenticationReducer(state = initialState, action)
// // {
  
// //   switch(action.type)
// //   {
// //     case REGISTER:
// //     return {
// //        ...state
// //     }
// //   }

// //   return state
// // }

// // export function authenticationReducer(state = initialState, action: All): State {
// //   switch (action.type) {
   
// //     case AuthActionTypes.TUPAS_SUCCESS: {
// //       return {
// //         ...state,
// //         tupasVerified: action.payload.tupasVerified,
// //         url:action.payload.url
// //       };
// //     }
// //     case AuthActionTypes.TUPAS_FAILURE: {
// //       return {
// //         ...state,
// //         tupasVerified:false,
// //         url:null
      
// //       };
// //     }
// //     default: {
// //       return {...state, success: null};
// //     }
// //   }
// // }

// export function defaultReducer(state = initialState, action: All): State {
//   return {...state};
//   }

// // export function registrationReducer(state = initialState, action: All): State {
// //   switch (action.type) {
// //     case AuthActionTypes.REGSUCCESS: {
// //       // alert("Hello")
// //       return {
// //         ...state,
// //         isAuthenticated: action.payload.isAuthenticated,
// //         user: {
// //           token: action.payload.token,
// //           email: action.payload.email
// //         },
// //         errorMessage: null,
// //         successMessage: action.payload.successMessage,
// //         error: null,
// //         success: action.payload.success
// //       };
// //     }
// //     case AuthActionTypes.REGFAILURE: {
// //       return {
// //         ...state,
// //         errorMessage: action.payload.error.message,
// //         error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
// //         success: action.payload.error.success
        
// //       };
// //     }
// //     default: {
// //       return {...state, success: null};
// //     }
// //   }
// // }

// export function loginReducer(state = initialState, action: All): State {
//   switch (action.type) {

//     case AuthActionTypes.LOGSUCCESS: {
//       // alert("Hello")
//       return {
//         ...state,
//         isAuthenticated: action.payload.isAuthenticated,
//         user: {
//           token: action.payload.token,
//           email: action.payload.email
//         },
//         errorMessage: null,
//         successMessage: action.payload.successMessage,
//         error: null,
//         success: action.payload.success
//       };
//     }

//     case AuthActionTypes.LOGFAILURE: {
//       return {
//         ...state,
//         errorMessage: action.payload.error.message,
//         error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
//         success: action.payload.error.success
        
//       };
//     }
//     case AuthActionTypes.LOGOUT: {
//       return {
//          ...state,
//          isAuthenticated: false
//        };
//      }
 
//      case AuthActionTypes.LOGOUTSUCCESS: {
//        // alert("Hello")
//        return {
//          ...state,
//          isAuthenticated: action.payload.isAuthenticated
         
//        };
//      }
 
//      case AuthActionTypes.LOGOUTFAILURE: {
//        return {
//          ...state,
//          errorMessage: action.payload.error.message,
//          error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
//          success: action.payload.error.success
         
//        };
//      }
//     default: {
//       return initialState
//     }
//   }
// }

// // export function logoutReducer(state = initialState, action: All): State {
// //   switch (action.type) {

// //     case AuthActionTypes.LOGOUT: {
// //      return {
// //         ...state,
// //         isAuthenticated: false
// //       };
// //     }

// //     case AuthActionTypes.LOGOUTSUCCESS: {
// //       // alert("Hello")
// //       return {
// //         ...state,
// //         isAuthenticated: action.payload.isAuthenticated
        
// //       };
// //     }

// //     case AuthActionTypes.LOGOUTFAILURE: {
// //       return {
// //         ...state,
// //         errorMessage: action.payload.error.message,
// //         error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
// //         success: action.payload.error.success
        
// //       };
// //     }

// //     default: {
// //       return state
// //     }
// //   }
// // }
// export interface State {
//   // is a user authenticated?
//   isAuthenticated: boolean;
//   // if authenticated, there should be a user object
//   user: User | null;
//   // error message
//   errorMessage: string | null;
// }







import {AuthActionTypes, All } from '../actions/authenticationActions';
import { User } from '../../app/core/interfaces/user';


export interface State {
  // is a user authenticated?
  isAuthenticated: boolean;
  // if authenticated, there should be a user object
  user: User | null;
  // error message
  errorMessage: string | null;

  successMessage: string | null;
  

  tupasVerified : boolean;

  success : boolean,

  url:string | null;

  error: string | null;

  action: string,

  name: string
}

const initialState: State = {
  isAuthenticated: localStorage.getItem("token") && true || false,
  user:  null,
  errorMessage: null,
  successMessage: null,
  tupasVerified:false,
  success: null,
  url:null,
  error:null,
  action: '',
  name:  localStorage.getItem("name") || ''
};


export function reducer(state:State=initialState, action: All): State {
  switch (action.type) {

    case AuthActionTypes.DEFAULTSTATE: {
      return initialState;
    }
    
    case AuthActionTypes.LOGSUCCESS: {
      return {
       
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        user: {
          token: action.payload.token,
          email: action.payload.email,
          name: localStorage.getItem("name") || action.payload.name 
        },
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        action:'login'
      };
    }
    case AuthActionTypes.LOGFAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        action: 'login'
      };
    }
    case AuthActionTypes.REGSUCCESS: {
           return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        user: {
          token: action.payload.token,
          email: action.payload.email,
          name:  localStorage.getItem("name") ||  action.payload.name
        },
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        action: 'register'
      };
    }
    case AuthActionTypes.REGFAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        action: 'register'
        
      }
    }

      case AuthActionTypes.TUPAS_SUCCESS: {
      return {
        ...state,
        tupasVerified: action.payload.tupasVerified,
        successMessage: action.payload.successMessage,
        success: action.payload.success,
        url:action.payload.url,
        action:'tupas'
      };
    }
    case AuthActionTypes.TUPAS_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        action:'tupas'
      
      }
    }

    case AuthActionTypes.LOGOUT: {
      return initialState;
    }
    // case AuthActionTypes.LOGIN: {
    //   return initialState;
    // }
        case AuthActionTypes.LOGOUTSUCCESS: {
      // alert("Hello")
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        action: 'logout'
        
      };
    }

    case AuthActionTypes.LOGOUTFAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        action: 'logout'
      };
    }
    default: {
      return state;
    }
  }
}
